// src/utils/countries.js

export const countryOptions = [
  { code: "CL", label: "Chile", flag: "🇨🇱" },
  { code: "AR", label: "Argentina", flag: "🇦🇷" },
  { code: "PE", label: "Perú", flag: "🇵🇪" },
  { code: "BR", label: "Brasil", flag: "🇧🇷" },
  { code: "UY", label: "Uruguay", flag: "🇺🇾" },
  { code: "BO", label: "Bolivia", flag: "🇧🇴" },
  { code: "PY", label: "Paraguay", flag: "🇵🇾" },
  { code: "CO", label: "Colombia", flag: "🇨🇴" },
  { code: "VE", label: "Venezuela", flag: "🇻🇪" },
  { code: "MX", label: "México", flag: "🇲🇽" },
  { code: "US", label: "Estados Unidos", flag: "🇺🇸" },
  { code: "CA", label: "Canadá", flag: "🇨🇦" },
  { code: "ES", label: "España", flag: "🇪🇸" },
  { code: "IT", label: "Italia", flag: "🇮🇹" },
  // Puedes agregar todos los que quieras
];

// Template visual para mostrar bandera + nombre
export const countryOptionTemplate = (option) => {
  if (!option) return null;
  return (
    <div className="flex align-items-center gap-2">
      <span style={{ fontSize: "1.2rem" }}>{option.flag}</span>
      <span>{option.label}</span>
    </div>
  );
};
